import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {mapiqApi, ParkingLotDto} from '@lib/infrastructure';
import {getIsFeatureEnabled} from '../../infrastructure/features';
import {FeatureToggle} from '../entities';

export const loadParkingLots = createAsyncThunk<ParkingLotDto[], void, AppThunkApiConfig>(
  'parkingLots/loadParkingLots',
  async (_, {extra, getState}) => {
    if (!getIsFeatureEnabled(getState(), FeatureToggle.Parking)) {
      return [];
    }
    const client = extra.apiClient;
    const api = mapiqApi(client);
    const response = await api.getParkingLots();
    return response;
  },
);
